import * as React from "react";
const SvgAgentPermissionsIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 32, cy: 32.001, r: 32.001, fill: "#A5BEFF", style: {
  fill: "#A5BEFF",
  fill: "color(display-p3 0.6471 0.7451 1.0000)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M28.0495 9.84806C30.0877 7.38398 33.912 7.38398 35.9502 9.84806L42.2038 20.9427L51.6575 28.8372C53.1815 30.6797 53.1815 33.3218 51.6575 35.1643L42.2038 43.0588L35.9502 54.1534C33.912 56.6175 30.0877 56.6175 28.0495 54.1534L21.7959 43.0588L12.3422 35.1643C10.8182 33.3218 10.8182 30.6797 12.3422 28.8372L21.7959 20.9427L28.0495 9.84806Z", fill: "#E1EBFF", style: {
  fill: "#E1EBFF",
  fill: "color(display-p3 0.8824 0.9216 1.0000)",
  fillOpacity: 1
} }));
export default SvgAgentPermissionsIcon;
